export class Settings {
  public constructor(private settings: Setting[]) {}

  public getString(key: number): string | undefined {
    return this.settings.find(setting => setting.key === key)?.value;
  }

  public getStringOrDefault(key: number, defaultValue: string): string {
    return (
      this.settings.find(setting => setting.key === key)?.value ?? defaultValue
    );
  }

  public getNumber(key: number): number | undefined {
    const value = this.getString(key);
    return value !== undefined ? parseInt(value, 10) : undefined;
  }

  public getNumberOrDefault(key: number, defaultValue: number): number {
    const value = this.getString(key);
    return value !== undefined ? parseInt(value, 10) : defaultValue;
  }

  public hasAny(): boolean {
    return this.settings.length > 0;
  }

  public static from(data: Setting[]): Settings {
    return new Settings(data.map(item => Setting.from(item)));
  }
}

export class Setting {
  public constructor(
    public key: number,
    public value: string
  ) {}

  public static from(data: Setting): Setting {
    return new Setting(data.key, data.value);
  }
}
